import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/lottery/act/list'
    return request.post(url,data)
}

export function all() {
    let url = '/lottery/act/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/lottery/act/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/lottery/act/info/' + id
    return request.get(url)
}
export function updateLottery(id) {
    let url = '/lottery/act/updateLottery/' + id
    return request.get(url)
}
export function renew(id) {
    let url = '/lottery/act/renew/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/lottery/act/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/lottery/act/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/lottery/act/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/lottery/act/dmz/options'
    return request.get(url)
}
